var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00976604 1.75C0.00976616 0.783502 0.793268 -5.96046e-08 1.75977 0L6.75977 4.17233e-07C7.72626 5.36442e-07 8.50977 0.783502 8.50977 1.75L8.50977 6.75C8.50977 7.7165 7.72626 8.5 6.75977 8.5L1.75977 8.5C0.793267 8.5 0.00976557 7.7165 0.00976563 6.75L0.00976604 1.75ZM1.75977 1.5C1.62169 1.5 1.50977 1.61193 1.50977 1.75L1.50977 6.75C1.50977 6.88807 1.62169 7 1.75977 7L6.75977 7C6.89784 7 7.00977 6.88807 7.00977 6.75L7.00977 1.75C7.00977 1.61193 6.89784 1.5 6.75977 1.5L1.75977 1.5Z",
    fill: "#225EAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.25C5.96047e-08 10.8358 0.335786 10.5 0.75 10.5H0.76C1.17421 10.5 1.51 10.8358 1.51 11.25C1.51 11.6642 1.17421 12 0.76 12H0.75C0.335786 12 -5.96046e-08 11.6642 0 11.25Z",
    fill: "#225EAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1274 14.25C10.1274 13.8358 10.4632 13.5 10.8774 13.5H10.8874C11.3017 13.5 11.6374 13.8358 11.6374 14.25C11.6374 14.6642 11.3017 15 10.8874 15H10.8774C10.4632 15 10.1274 14.6642 10.1274 14.25Z",
    fill: "#225EAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75488 14.25C6.75488 13.8358 7.09067 13.5 7.50488 13.5H7.51488C7.9291 13.5 8.26488 13.8358 8.26488 14.25C8.26488 14.6642 7.9291 15 7.51488 15H7.50488C7.09067 15 6.75488 14.6642 6.75488 14.25Z",
    fill: "#225EAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38232 14.25C3.38232 13.8358 3.71811 13.5 4.13232 13.5H4.14232C4.55654 13.5 4.89232 13.8358 4.89232 14.25C4.89232 14.6642 4.55654 15 4.14232 15H4.13232C3.71811 15 3.38232 14.6642 3.38232 14.25Z",
    fill: "#225EAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00976563 14.25C0.00976568 13.8358 0.345552 13.5 0.759766 13.5H0.769766C1.18398 13.5 1.51977 13.8358 1.51977 14.25C1.51977 14.6642 1.18398 15 0.769766 15H0.759766C0.345552 15 0.00976557 14.6642 0.00976563 14.25Z",
    fill: "#225EAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2598 0C14.674 0 15.0098 0.335786 15.0098 0.75V0.76C15.0098 1.17421 14.674 1.51 14.2598 1.51C13.8456 1.51 13.5098 1.17421 13.5098 0.76V0.75C13.5098 0.335786 13.8456 0 14.2598 0Z",
    fill: "#225EAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2598 3.37305C14.674 3.37305 15.0098 3.70883 15.0098 4.12305V4.13305C15.0098 4.54726 14.674 4.88305 14.2598 4.88305C13.8456 4.88305 13.5098 4.54726 13.5098 4.13305V4.12305C13.5098 3.70883 13.8456 3.37305 14.2598 3.37305Z",
    fill: "#225EAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2598 6.74414C14.674 6.74414 15.0098 7.07993 15.0098 7.49414V7.50414C15.0098 7.91835 14.674 8.25414 14.2598 8.25414C13.8456 8.25414 13.5098 7.91835 13.5098 7.50414V7.49414C13.5098 7.07993 13.8456 6.74414 14.2598 6.74414Z",
    fill: "#225EAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2598 10.1172C14.674 10.1172 15.0098 10.453 15.0098 10.8672V10.8772C15.0098 11.2914 14.674 11.6272 14.2598 11.6272C13.8456 11.6272 13.5098 11.2914 13.5098 10.8772V10.8672C13.5098 10.453 13.8456 10.1172 14.2598 10.1172Z",
    fill: "#225EAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2598 13.4902C14.674 13.4902 15.0098 13.826 15.0098 14.2402V14.2502C15.0098 14.6644 14.674 15.0002 14.2598 15.0002C13.8456 15.0002 13.5098 14.6644 13.5098 14.2502V14.2402C13.5098 13.826 13.8456 13.4902 14.2598 13.4902Z",
    fill: "#225EAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0.75C10.5 0.335786 10.8358 -5.96046e-08 11.25 0H11.26C11.6742 5.96047e-08 12.01 0.335786 12.01 0.75C12.01 1.16421 11.6742 1.5 11.26 1.5H11.25C10.8358 1.5 10.5 1.16421 10.5 0.75Z",
    fill: "#225EAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomise);
export default __webpack_public_path__ + "static/media/customise.d7c58ef13eece6ea0a3355323c0a6a41.svg";
export { ForwardRef as ReactComponent };